import React from "react";
import styles from "./leyenda-grafico-proyecciones.module.css";

const LeyendaGraficoProyecciones = ({ escenarios }) => {
    return (
        <div className={styles.contenedor}>
            {escenarios.map((escenario, index) => (
                <div key={'escenario_' + index}>
                    <div className={styles.leyenda_titulo}>
                        <div className={`${styles.leyenda_point} ${styles['leyenda_' + escenario.nombre.replace(' ', '_')]}`} />
                        <span className={styles.leyenda_texto}>{escenario.nombre}</span>
                    </div>
                    <div className={styles.leyenda_comentario}>
                        <span className={`${styles.leyenda_texto} ${styles.negrita}`}>
                            {escenario.descripcionTir}
                        </span>
                        <span className={styles.leyenda_descripcion}>
                            {escenario.descripcion !== null 
                                ? escenario.descripcion.substr(0, escenario.descripcion.indexOf('.') + 1)
                                : ''}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default LeyendaGraficoProyecciones;